export function IDMapper(ID: number) {
    if (ID > 3) return ID;
    if (ID === 1) return 14;
    if (ID === 2) return 18;
    if (ID === 3) return 20;
}
